var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// constants
import Routes from '@/constants/Routes';
import { IconCicularLoader } from '@/constants/icons/svg';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// api
import { signInWithIDP } from '@/includes/api/auth';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// styles
import styles from './login.module.scss';
export default function LoginSuccess(props) {
    const [isError, setIsError] = useState(false);
    const called = useRef(false);
    const navigate = useNavigate();
    useEffect(() => {
        if (called.current) {
            return;
        }
        called.current = true;
        initiateSignIn();
    }, []);
    const initiateSignIn = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const url = new URL(window.location.href);
            const code = url.searchParams.get('code');
            const successCb = () => {
                props.handleLoginSuccess(true);
                navigate(Routes.INSTAMART_HOME, {
                    replace: true,
                    preventScrollReset: true,
                });
            };
            if (code) {
                yield signInWithIDP(code, successCb);
            }
        }
        catch (_a) {
            setIsError(true);
        }
    });
    const renderSigningLoader = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(IconCicularLoader, { height: 108, width: 108, className: styles.loader }),
            React.createElement(Text, { className: styles.containerHeader, variant: DlsFontVariants.header_H4_Med, color: DlsColorTokens.text_Highest_Emphasis },
                "Signing in...",
                React.createElement("br", null),
                "Please do not hit back or refresh!")));
    };
    const renderError = () => {
        return (React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Med_Emphasis }, "Something went wrong!"));
    };
    return (React.createElement("div", { className: styles.container }, isError ? renderError() : renderSigningLoader()));
}
